// *******~ Import ~******** //
//? React
import { useState } from "react";
//? Assets
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Player } from "@lottiefiles/react-lottie-player";
import AboutLottie from "./img/slide.json";
//? Components
import Contact from "../../../contact/contact";
//? CSS
import "./about.scss";
//? Images

//? JSON File

//? Icons
// import { FaHtml5 } from "react-icons/fa";
import { VscDebugBreakpointLog } from "react-icons/vsc";
import { MdOutlineContacts } from "react-icons/md";

// *******~ Import ~******** //

const About = () => {
  const [Contactshow, setContactshow] = useState(false);

  const ContacthandleShow = () => setContactshow(true);
  const AboutContent = [
  "I am currently an ERP Developer with 1.6 years of experience, focused on developing and customizing solutions using the Frappe Framework and ERPNext.",
  "I have worked on multiple modules, building custom DocTypes, server/client scripts, print formats, and workflows to meet specific business requirements.",
  "Prior to this, I worked as a Mobile and Web Developer, contributing to cross-platform projects using React Native and Flutter, as well as web applications built with React.js, Bootstrap, Material UI, and SASS.",
  "I bring a strong foundation in Python, JavaScript, HTML, and CSS, with hands-on experience in building clean, responsive UI components that align with user experience goals.",
  "I ensure cross-browser and cross-device compatibility using Flexbox, Grid, and media queries to deliver consistent layouts across screen sizes.",
  "I follow clean version control practices using Git and GitHub, promoting collaborative and maintainable development workflows.",
  "With a solid background in both frontend and ERP systems, I bridge business logic with user-friendly design to deliver complete, scalable solutions."
]
  return (
    <>
      <span id="about"></span>
      <section className="about-section">
        <Container>
          <Row className="align-items-center justify-content-center">
            <Col xxl={5} md={8} lg={5}>
              <div className="lottie-ani" data-aos="fade-up">
                <Player autoplay loop src={AboutLottie}></Player>
              </div>
            </Col>
            <Col xxl={7} md={12} lg={7}>
              <div className="heading">
                <h2 data-aos="fade-up">About Me</h2>
                <p data-aos="fade-up">
                  “Crazy <span>ERP Developer</span> Who Wants to Explore
                  Every Tech Staks”
                </p>
              </div>
              <ul>
                {AboutContent.map((data, index) => (
                  <>
                    <li key={index} data-aos="fade-up">
                      <VscDebugBreakpointLog /> <p>{data}</p>
                    </li>
                  </>
                ))}
              </ul>
              <button onClick={ContacthandleShow}>
                <MdOutlineContacts />
                Contact Me
              </button>
              {/* <div className="icons-div">
                <ul>
                  <li>
                    <FaHtml5 />
                    HTML
                  </li>
                </ul>
              </div> */}
            </Col>
          </Row>
        </Container>
      </section>
      <Contact Contactshow={Contactshow} setContactshow={setContactshow} />
    </>
  );
};
export default About;
